export const information = {
    location: '1220 Hobson Road, Suite 224, Naperville, IL 60540',
    locationUrl:
        'https://www.google.com/maps/place/Just+For+Kids+Pediatric+Dentistry;+Dr.+Eryn+%26+Dr.+Maribel/@41.7527554,-109.2069576,4z/data=!4m7!3m6!1s0x880e57666dd95c0d:0x2e741d07c5b9091f!8m2!3d41.7527554!4d-88.1132076!15sChRqdXN0IGZvciBraWRzIGRlbnRhbFoWIhRqdXN0IGZvciBraWRzIGRlbnRhbJIBEXBlZGlhdHJpY19kZW50aXN0mgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVVF0TkVscGRGUjNFQUXgAQA!16s%2Fg%2F1v6p9fjy?entry=tts&shorturl=1',
    phone: '(630) 961-0996',
    fax: '(630) 579-0850',
};
